<template>
  <div class="container py-3">
    <div class="breadcrumb-voucher py-3">
      <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
          <li class="breadcrumb-item">
            <router-link to="/">
              <Icon class="color--info" name="house" />
            </router-link>
          </li>
          <li class="breadcrumb-item">
            <router-link class="color--info" to="/">
              Emissão de Certificado
            </router-link>
          </li>
          <li class="breadcrumb-item">
            <router-link class="color--primary disabled fw-600" to="/">
              Certificado SSL
            </router-link>
          </li>
        </ol>
      </nav>
    </div>

    <Wizzard current-page="alldone" />

    <h2 class="w-100 fw-600 text-start mt-5">
      Pra terminar, vamos validar seu domínio
    </h2>

    <div class="row pt-5">
      <div class="d-none d-lg-block col-lg-5 d-flex justify-content-center">
        <img
          id="domain-validation-image"
          src="@/assets/images/domain-validation.svg"
          alt="domain-validation"
        />
      </div>
      <div class="col-12 col-lg-7 d-flex flex-column justify-content-start">
        <router-link
          to="/domain-validation/validation"
          class="text-start text link-info"
        >
          <Icon name="angle-left" />
          Escolher outro tipo de validação
        </router-link>

        <h3 class="fs-5 fw-400 text-start mt-3 mb-4">
          Validação de domínio via HTTP
        </h3>

        <p class="text-start fs-6">
          <strong>Domínio:</strong> www.{{ domain }}
        </p>

        <p class="text-start">
          Para completar a validação de controle de domínio para este
          certificado, siga as instruções abaixo:
        </p>

        <div class="text-start mb-4">
          <p class="text-start">1. Faça o download do arquivo de validação</p>

          <button class="btn btn-info btn-sm" @click="downloadValidationFile">
            <span class="me-2">Baixar arquivo de validação</span>
            <Icon name="download" />
          </button>
        </div>

        <div class="text-start mb-4">
          <p class="text-start">
            2. Crie a pasta
            <span class="fst-italic fw-500">"{{ firstFolder }}”</span>
            e, dentro dela, crie outra pasta
            <span class="fst-italic fw-500">"{{ secondFolder }}”</span>
          </p>

          <div class="gray-space">
            <span class="text">
              <span class="fw-500">Exemplo:</span>
              www.{{ domain }}/{{ firstFolder }}/{{ secondFolder }}
            </span>
          </div>
        </div>

        <div class="text-start mb-4">
          <p class="text-start">
            3. Faça upload do arquivo de validação dentro da pasta
            <span class="fst-italic fw-500">"{{ secondFolder }}”</span>
          </p>

          <div class="gray-space mb-3">
            <span class="text">
              <span class="fw-500">Exemplo:</span>
              <br />
              {{ links[0] }}
              <br />
              {{ links[1] }}
            </span>
          </div>

          <div class="alert alert-dismissible alert-warning" role="alert">
            <div class="alert__icon">
              <Icon name="circle-exclamation" />
            </div>
            <div class="alert__content">
              <span class="text">
                Importante: o nome e o conteúdo do arquivo não devem ser
                alterados.
              </span>
            </div>
          </div>

          <div class="alert alert-dismissible" role="alert">
            <div class="alert__icon">
              <Icon name="lightbulb" />
            </div>
            <div class="alert__content">
              <span class="text">
                Depois que o domínio estiver validado, você poderá deletar as
                pastas!
              </span>
            </div>
          </div>
        </div>

        <div class="text-start">
          <p class="text-start">
            4. Após finalizar os passos acima, clique no botão abaixo para
            iniciar a validação do domínio.
          </p>

          <div class="d-flex flex-column gap-4">
            <button
              id="validate-domain-button"
              class="btn btn-primary"
              @click="validateDomain"
            >
              <span class="me-2">Validar domínio</span>
              <Icon name="globe" />
            </button>

            <!-- <button
              id="wish-to-validate-later-button"
              class="btn btn-outline-primary"
              @click="openModalAwait"
            >
              <span class="me-2">Desejo fazer a validação mais tarde</span>
            </button> -->
          </div>
        </div>
      </div>
    </div>

    <Contact />

    <ModalAwaitVue />
    <button
      v-show="false"
      id="modal-await-button"
      type="button"
      data-bs-toggle="modal"
      data-bs-target="#modal-await"
    />
  </div>
</template>

<script lang="ts">
  import { defineComponent } from 'vue'
  import { useModalLoading } from '@/store/Pinia/useModalLoading.store'
  import { mapActions, mapState } from 'pinia'
  import Icon from '@/components/Atoms/Icon.vue'
  import Wizzard from '@/components/Molecules/Wizzard.vue'
  import Contact from '@/components/Molecules/Contact.vue'
  import { useDomainValidation } from '@/store/Pinia/useDomainValidation.store'
  import httpValidationController from '@/infra/DomainValidation/http.controller'
  import { useDynamicForms } from '@/store/Pinia/useDynamicForms.store'
  import { useSolicitation } from '@/store/Pinia/useSolicitation.store'
  import { useToastGlobal } from '@/store/Pinia/useToastGlobal.store'
  import ModalAwaitVue from './ModalAwait.vue'

  export default defineComponent({
    components: {
      Icon,
      Wizzard,
      Contact,
      ModalAwaitVue,
    },
    data() {
      return {
        domain: '',
        firstFolder: '',
        secondFolder: '',
        links: Array<string>(),
        validationFileContent: '',
        validationFileName: '',
      }
    },
    computed: {
      ...mapState(useDomainValidation, ['domainHttpValidationData']),
      ...mapState(useDynamicForms, ['getPassword']),
      ...mapState(useSolicitation, ['getSolicitation']),
    },
    methods: {
      ...mapActions(useModalLoading, ['setIsLoading']),
      ...mapActions(useToastGlobal, ['toggleToastGlobal']),
      ...mapActions(useDomainValidation, ['clearDomainHttpValidationData']),
      openModalAwait() {
        ;(
          document.getElementById('modal-await-button') as HTMLButtonElement
        ).click()
      },
      downloadValidationFile() {
        const blob = new Blob([this.validationFileContent], {
          type: 'text/plain;charset=utf-8',
        })
        const link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = this.validationFileName
        link.click()
      },
      async validateDomain() {
        try {
          this.setIsLoading({
            isLoading: true,
            title: 'Aguarde enquanto validamos seu domínio.',
            message: '',
            image: 'clock',
          })

          await httpValidationController.validate({
            codigo: this.getSolicitation.cdSolicitacao,
            senha: this.getPassword,
            domain: this.domain,
          })

          this.clearDomainHttpValidationData()

          if (!this.getSolicitation.isQsa) {
            return this.$router.push({
              path: '/domain-validation/validation-success/feedback-http-dns-later-wo-qsa',
            })
          }

          return this.$router.push({
            path: '/domain-validation/validation-success/feedback-http-dns-later-w-qsa',
          })
        } catch (_error) {
          return this.toggleToastGlobal({
            isShow: true,
            type: 'danger',
            message: 'Erro ao validar o domínio',
          })
        } finally {
          setTimeout(() => {
            this.setIsLoading({ isLoading: false })
          }, 1000)
        }
      },
    },
    mounted() {
      this.domain = this.domainHttpValidationData.domain
      // eslint-disable-next-line prefer-destructuring
      this.firstFolder =
        this.domainHttpValidationData.check_endpoint.split('/')[1]
      // eslint-disable-next-line prefer-destructuring
      this.secondFolder =
        this.domainHttpValidationData.check_endpoint.split('/')[2]
      this.links = this.domainHttpValidationData.links
      this.validationFileContent = this.domainHttpValidationData.file_content
      this.validationFileName = this.domainHttpValidationData.file_name
    },
    beforeRouteEnter(to, from, next) {
      const solicitationStore = useSolicitation()
      if (solicitationStore.getSolicitation.cdSolicitacao === '') {
        return next('/')
      }
      return next()
    },
  })
</script>

<style scoped>
  .gray-space {
    background: #f0f0f3;
    padding: 4px 8px;
  }

  #validate-domain-button,
  #wish-to-validate-later-button {
    width: fit-content;
  }

  @media screen and (max-width: 992px) {
    #validate-domain-button,
    #wish-to-validate-later-button {
      width: 100%;
    }
  }
</style>
